import { render, staticRenderFns } from "./LogbookWidget.vue?vue&type=template&id=f1286b92&scoped=true&"
import script from "./LogbookWidget.vue?vue&type=script&lang=js&"
export * from "./LogbookWidget.vue?vue&type=script&lang=js&"
import style0 from "./LogbookWidget.vue?vue&type=style&index=0&id=f1286b92&scoped=true&lang=css&"
import style1 from "./LogbookWidget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1286b92",
  null
  
)

export default component.exports